import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { hasRole } from '../../config/menuConfig';

/**
 * ProtectedRoute — Guards routes based on authentication AND optional role.
 *
 * @param {React.ReactNode} children - The component to render if authorized.
 * @param {string[]} requiredRoles - Optional list of roles that can access this route.
 *   If empty, any authenticated user is allowed.
 */
function ProtectedRoute({ children, requiredRoles = [] }) {
  const { isAuthenticated, usuario } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (requiredRoles.length > 0 && !hasRole(usuario, requiredRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default ProtectedRoute;
